// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".separator{width:1px;background-color:var(--text-light);height:17.5px}.previewMaximized .editor-panel{flex-basis:0!important}.previewMaximized #code-editor{opacity:0;height:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
